<template>
  <div class="page-content">




    <v-row>
      <v-col cols="12" sm="12" >
        <h1 class="page-title"> <span >{{$t('talkingAboutUs.pageHeader')}}</span></h1>

      </v-col>

    </v-row>


      <div style="    padding: 0 12px;">
          <v-card
                  class="pa-4 stats-card "
                  style="border:5px;    height: auto;"


          >
              <p class="card-body " style="font-size:14px;margin-bottom:0;" v-html="$t('talkingAboutUs.pageSubtitle')">

              </p>
          </v-card>
      </div>



   <br>
      <v-col class="blog-post-card" md="12" lg="12" sm="12" v-for="(item, index  ) in talkingAboutUsVideos"
             :key="index" style="display:inline-block;position:relative;">
          <div class="blog-post-image">
              <iframe height="130" class="elevation-1"   :src="'https://www.youtube.com/embed/' + item.videoId" style="width:100%"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

          </div>
          <v-card
                  class="mx-auto"
                  style="padding-left:250px;min-height: 160px;"

          >


              <v-card-title>
                  <a :href="'https://www.youtube.com/watch?v='+item.videoId" style="text-decoration: none;"
                               class="text--primary"> {{item.header}}
                  </a>
              </v-card-title>


              <v-card-subtitle class="pb-0" v-text="item.subject"></v-card-subtitle>

              <v-card-text class="text--primary" v-text="item.subtitle">

              </v-card-text>

              <v-card-actions >
                  <!--<router-link :to="'article/'+item.link" style="text-decoration: none;">-->
                  <a :href="'https://www.youtube.com/watch?v='+item.videoId">
                      <v-btn
                              color="pink"
                              text
                              class="float-right"

                      >
                          <span v-html="$t('talkingAboutUs.watchVideo')"></span>
                      </v-btn>
                  </a>
                  <!--</router-link>-->
                  <v-spacer></v-spacer>
                  <div style="font-weight:300;margin-right:15px;font-size:14px!important;">

                  </div>
              </v-card-actions>
          </v-card>
      </v-col>

    <br><br>    <br><br>

  </div>
</template>

<style>

    .mobile .blog-post-card .v-card {
        padding-left: 0 !important;
        padding-top: 150px;
    }

    .blog-post-image {
        position: absolute;
        left: 11px;
        top: 0px;
        bottom: 0px;
        margin: auto;
        z-index: 2;
        height: 161px;
        width: 250px;
    }

    .mobile .blog-post-card .blog-post-image {
        height: 100px;
        position: absolute;
        left: 0;
        right: 0;
        top: 45px;
        bottom: auto;
    }

    .blog-post-image iframe {

        width: 90%!important; height: 130px; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; border-radius: 3px; overflow: hidden;

    }

    .text-action {

        color: #EF44AE;
        background: linear-gradient(90deg, rgba(255, 81, 82, 1) 0%, rgba(255, 55, 117, 1) 49%, rgba(254, 0, 148, 1) 100%);;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

    }

  .page-title {
    font-weight:300;font-size:27px;margin-top:5px;margin-bottom:15px;
  }

  .mobile .page-title {
    text-align: center;
  }

</style>

<script>

    import { mapState } from 'vuex'

  export default {
    name: 'talking-about-us',

    computed: {
        ...mapState(['talkingAboutUsVideos']),

    }
  };
</script>
